import { faUser } from "@fortawesome/fontawesome-free-solid";
import { faGear, faRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useNavigate } from "react-router-dom";
import drivado_logo from "../../assets/drivado_logo.png";
import DropDown from "./DropDown";

import { styled, alpha } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";


const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

const Header = (token) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const [dropDownOpen, setdropDownOpen] = useState(false);

  // dropdown menu
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {token?.token ? (
        <>
          <div className="bg-[#f1f1f1] w-full h-[50px] flex justify-between items-center px-5 lg:px-10 static">
            {/* menuicon when it is in mobile view */}

            <div className="lg:hidden md:hidden">
              {/* <MenuIcon className="w-7" /> */}
              <DropDown />
            </div>

            {/* drivado logo */}
            <div className="md:text-red-500 md:inline-block">
              <Link to="/">
                <img
                  src={drivado_logo}
                  className="w-[140px] h-10"
                  alt="Drivado Icon"
                />
              </Link>
            </div>

            {/* menu items start */}
            <div className="hidden md:flex md:space-x-5 md:text-xs lg:flex lg:space-x-2 lg:text-xs mr-2">
              <div className="relative">
                <div>
                  <div className="w-[100%] flex items-center">
                    <div>
                      <div className="text-center">
                        {user?.firstName} {user?.lastName}
                      </div>
                      <div className="text-sm text-black font-semibold">
                        {user?.userName}
                      </div>
                    </div>
                    <FontAwesomeIcon
                      icon={faUser}
                      id="dropdownDefault"
                      data-dropdown-toggle="dropdown"
                      className="w-10 h-5 text-primary font-normal"
                      type="button"
                    />
                  </div>
                  {dropDownOpen && (
                    <>
                      <div
                        onMouseOver={() => {
                          setdropDownOpen(true);
                        }}
                        onMouseOut={() => {
                          setdropDownOpen(false);
                        }}
                        className="bg-slate-200 shadow-lg space-y-1 flex-wrap absolute text-base top-7 right-0 rounded-b-sm px-4 py-2 z-10"
                      >
                        <div className="flex items-center space-x-3 cursor-pointer hover:text-primary">
                          <FontAwesomeIcon
                            icon={faRightFromBracket}
                            className="w-3"
                          />
                          <div>Logout</div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            {/* menu items end */}
          </div>
        </>
      ) : (
        <>
          <div className="bg-white w-full h-[65px] flex justify-between items-center px-5 xl:px-40 2xl:px-56 lg:px-16 fixed top-0 z-10">
            {/* menuicon when it is in mobile view */}

            <div className="lg:hidden md:hidden">
              {/* <MenuIcon className="w-7" /> */}
              <DropDown />
            </div>

            {/* drivado logo */}
            <div className="md:text-red-500 md:inline-block">
              <Link to="/">
                <img
                  src={drivado_logo}
                  className="h-10 w-auto"
                  alt="Drivado Icon"
                />
              </Link>
            </div>

            {/* menu items */}
            <div className="hidden md:flex md:space-x-4 md:text-xs lg:flex lg:space-x-5  lg:text-xs ml-8 lg:ml-10">
              <NavLink
                to="/login"
                // className="headerMenuItem"
                className={({ isActive }) =>
                  isActive
                    ? "headerMenuItem text-primary hover:text-secondary"
                    : "headerMenuItem font-body"
                }
              >
                Client Login
              </NavLink>

              <NavLink
                to="/signup"
                // className="headerMenuItem"
                className={({ isActive }) =>
                  isActive
                    ? "headerMenuItem text-primary hover:text-secondary"
                    : "headerMenuItem font-body"
                }
              >
                Signup
              </NavLink>

              <div>
                <Button
                  id="demo-customized-button"
                  aria-controls={open ? "demo-customized-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  variant="contained"
                  disableElevation
                  onClick={handleClick}
                  endIcon={<KeyboardArrowDownIcon />}
                  className="font-body text-primary text-[14px] font-normal bg-white capitalize -mt-[3px]"
                >
                  Add-On Services
                </Button>
                <StyledMenu
                  id="demo-customized-menu"
                  MenuListProps={{
                    "aria-labelledby": "demo-customized-button",
                  }}
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                >
                  <MenuItem onClick={handleClose} disableRipple>
                    <NavLink to="/multiItinerary">Multi-City Itinerary</NavLink>
                  </MenuItem>
                  <Divider sx={{ my: 0.5 }} />
                  <MenuItem onClick={handleClose} disableRipple>
                    <NavLink to="/vipAssistance">
                      VIP Assistance at Airport
                    </NavLink>
                  </MenuItem>
                  <Divider sx={{ my: 0.5 }} />
                  <MenuItem onClick={handleClose} disableRipple>
                    <NavLink to="/unableTransfer">
                      Unable to find Transfer
                    </NavLink>
                  </MenuItem>
                </StyledMenu>
              </div>

              <NavLink
                to="/aboutUs"
                // className="headerMenuItem"
                className={({ isActive }) =>
                  isActive
                    ? "headerMenuItem text-primary hover:text-secondary"
                    : "headerMenuItem font-body"
                }
              >
                About Us
              </NavLink>
              <NavLink
                to="/contactUs"
                // className="headerMenuItem"
                className={({ isActive }) =>
                  isActive
                    ? "headerMenuItem text-primary hover:text-secondary"
                    : "headerMenuItem font-body"
                }
              >
                Contact Us
              </NavLink>
              {/* <div className="headerMenuItem">Currency</div> */}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Header;
